// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ursaring: PokeData = {
  "id": 217,
  "name": "ursaring",
  "height": 18,
  "weight": 1258,
  "base_experience": 175,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "tackle",
    "thrash",
    "double-edge",
    "leer",
    "lick",
    "fury-swipes",
    "rest",
    "slash",
    "snore",
    "scary-face",
    "feint-attack",
    "charm",
    "sweet-scent",
    "fake-tears",
    "covet",
    "hammer-arm",
    "payback",
    "fling",
    "bulldoze",
    "play-rough",
    "play-nice",
    "baby-doll-eyes",
    "high-horsepower"
  ],
  "moves": [
    "scratch",
    "tackle",
    "leer",
    "lick",
    "scary-face",
    "play-rough",
    "headbutt",
    "purification",
    "growl",
    "supersonic",
    "body-slam",
    "splash",
    "quick-attack"
  ],
  "evolution_chain": {
    "id": 110,
    "item": null,
    "species": [
      {
        "name": "teddiursa",
        "order": 247,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ursaring",
        "order": 248,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 216,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ursaluna",
        "order": 901,
        "types": [
          PokeType.GROUND,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 217,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "peat-block"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "full-moon",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 82.5,
    "speed": 55,
    "ability_power": 130
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
